// extracted by mini-css-extract-plugin
module.exports = {"input":"search-input_input__33JAx","icon":"search-input_icon__2DcwE"};